export default {
    namespaced: true,
    state: {
        menuData: []
    },
    mutations: {
        changeMenuData(state, menuData) {
            state.menuData = menuData
        }
    }
}
